import { TriangleAlert } from 'lucide-react'

interface ServiceAlertBannerProps {
  title: string
  actionLabel: string
  /** Opens the vendor's console — this is not something we can fix from here. */
  actionHref: string
}

/**
 * The blocking condition at the top of a vendor screen.
 *
 * Deliberately the brightest thing on the page: a light bar against the dark
 * shell, because the rest of the screen is diagnosis and this is the one row
 * that says someone has to act. The action leaves for the vendor's console, so
 * it is an anchor rather than a button — it navigates, and should behave like it
 * (middle-click, open in a new tab).
 */
export function ServiceAlertBanner({ title, actionLabel, actionHref }: ServiceAlertBannerProps) {
  return (
    <div
      role="alert"
      className="border-line-bright bg-fg text-canvas flex flex-wrap items-center gap-4 rounded-lg border px-4 py-3"
    >
      <TriangleAlert aria-hidden className="size-5 shrink-0" />
      <p className="min-w-0 flex-1 font-mono text-[13px] font-bold tracking-[0.04em] uppercase">
        {title}
      </p>
      <a
        href={actionHref}
        target="_blank"
        rel="noreferrer noopener"
        className="bg-critical hover:bg-critical/85 focus-visible:ring-critical/40 shrink-0 rounded-lg px-4 py-2 text-sm font-bold text-white transition-colors outline-none focus-visible:ring-2"
      >
        {actionLabel}
      </a>
    </div>
  )
}
